import { CrystallizeShapeHelper, ShapeContent } from '@/utils/crystallize-shape-helper';
import { ParsedSubnavData } from './types/subnav-types';

export function parseSubnavData(rawSubNavData: ShapeContent): ParsedSubnavData {
  const shapeHelper = new CrystallizeShapeHelper(rawSubNavData);
  const parsed = shapeHelper.getFlattened();

  return parsed as ParsedSubnavData;
}
